import * as moment from 'moment-timezone'

export function convertTimeInputToTimestamp(timeInput: string): string {
    const [hours, minutes] = timeInput.split(':').map(Number);
    const now = new Date();

    // Create a date with today's year, month, and day, but with the provided time in the local timezone.
    const dateWithTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);

    // Convert the local time to UTC using moment-timezone.
    const utcTime = moment.tz(dateWithTime, "Europe/Berlin").utc();

    return utcTime.toISOString();
}

export function convertTimestampToTimeString(timestamp: string): string {
    return  moment.utc(timestamp).tz("Europe/Berlin").format("HH:mm");
}

export function convertISOStringToDate(isoString: string): Date {
    return moment.utc(isoString).tz('Europe/Berlin').toDate()
}

export function convertDateToISOString(date: Date): string {
    return date.toISOString();
}
